import { StandardEvents } from '@shopify/events';

let pendingCardButton = null;
let restoreTimer = null;

const restoreButton = (button) => {
  if (!button) return;
  button.classList.remove('is-loading', 'is-added');
  button.textContent = button.dataset.oseaOriginalText || 'Añadir al carrito';
};

const injectCartExtras = () => {
  const summary = document.querySelector('#cart-drawer .cart-drawer__summary');
  if (!summary || summary.querySelector('[data-osea-cart-extras]')) return;

  const block = document.createElement('div');
  block.dataset.oseaCartExtras = '';
  block.innerHTML = `
    <p class="osea-cart-extras__title">Tu compra OSEA</p>
    <div class="osea-cart-extras__benefit"><b>🚚</b><span>Concepción: entrega estimada 1–2 días hábiles</span></div>
    <div class="osea-cart-extras__benefit"><b>✓</b><span>Facturación para empresas</span></div>
    <p class="osea-cart-extras__more">¿Necesitas algo más?</p>
    <div class="osea-cart-extras__chips">
      <a href="/#papel-higienico">Papel higiénico</a>
      <a href="/#toallas-de-papel">Toallas</a>
      <a href="/#jabones">Jabones</a>
    </div>`;
  summary.insertBefore(block, summary.firstChild);
};

const pulseHeaderCart = () => {
  const cartButton = document.querySelector('.osea-header-cart');
  if (!cartButton) return;
  cartButton.classList.remove('is-pulsing');
  void cartButton.offsetWidth;
  cartButton.classList.add('is-pulsing');
  setTimeout(() => cartButton.classList.remove('is-pulsing'), 550);
};

document.addEventListener('submit', (event) => {
  const form = event.target.closest?.('.osea-product-card__cart-form');
  if (!form) return;
  const button = form.querySelector('.osea-product-card__cart');
  if (!button) return;
  if (restoreTimer) clearTimeout(restoreTimer);
  pendingCardButton = button;
  button.dataset.oseaOriginalText ||= button.textContent.trim();
  button.textContent = 'Agregando…';
  button.classList.remove('is-added');
  button.classList.add('is-loading');
}, true);

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(({ detail }) => {
      const failed = Boolean(detail?.didError);
      if (event.action === 'add') {
        if (failed) {
          restoreButton(pendingCardButton);
        } else {
          if (pendingCardButton) {
            pendingCardButton.classList.remove('is-loading');
            pendingCardButton.classList.add('is-added');
            pendingCardButton.textContent = '✓ Agregado al carrito';
            const buttonToRestore = pendingCardButton;
            restoreTimer = setTimeout(() => restoreButton(buttonToRestore), 1500);
          }
          pulseHeaderCart();
          const drawer = document.querySelector('#cart-drawer');
          if (typeof drawer?.open === 'function') drawer.open();
        }
        pendingCardButton = null;
      }
      requestAnimationFrame(injectCartExtras);
    })
    .catch(() => {
      restoreButton(pendingCardButton);
      pendingCardButton = null;
    });
});

document.addEventListener('DOMContentLoaded', () => {
  injectCartExtras();
  setTimeout(injectCartExtras, 600);
});
